//defines the different quiz status
export const start = 'start';
export const question = 'question';
export const end = 'end';
export const results = 'results';
export const countdown = 'countdown';